import { render } from "./HpoPatientModalPhcSection.vue?vue&type=template&id=0c1920a5"
import script from "./HpoPatientModalPhcSection.vue?vue&type=script&lang=js"
export * from "./HpoPatientModalPhcSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__